export const Loader = ({ label = "Loading..." }) => (
  <div className="flex items-center justify-center py-20" data-testid="loader">
    <div className="flex flex-col items-center gap-3">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-muted border-t-[hsl(var(--brand-red))]" />
      <span className="text-sm text-muted-foreground">{label}</span>
    </div>
  </div>
);

export const EmptyState = ({ title = "Nothing here yet", description }) => (
  <div className="rounded-lg border border-dashed border-border py-16 text-center">
    <p className="font-condensed text-lg font-semibold uppercase">{title}</p>
    {description && <p className="mt-1 text-sm text-muted-foreground">{description}</p>}
  </div>
);

// Renders the standard loading → empty → data flow without nested ternaries.
export const AsyncState = ({ loading, empty, emptyTitle, emptyDescription, children }) => {
  if (loading) return <Loader />;
  if (empty) return <EmptyState title={emptyTitle} description={emptyDescription} />;
  return children;
};
